import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as t from "./types";
import * as actions from "./action";

export function* setGlobalMessageSaga(action: t.SetGlobalMessageActionType) {
  try {
    yield put({
      type: actions.SET_GLOBAL_MESSAGE_SUCCESS,
      response: action.payload.message,
    });
  } catch (error) {
    yield put({ type: actions.SET_GLOBAL_MESSAGE_ERROR, response: undefined });
  }
}
